import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import { areas } from 'constants/areas';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ADMIN_LEASING_EXPENSE_TYPES_READ } from 'constants/rightsCodes';
import LeasingExpenseTypeContainer from './generalData/LeasingExpenseTypeContainer';
import PermissionCheck from 'components/common/PermissionCheck';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { useReactiveVar } from '@apollo/client';
import { expenseNameVar } from '../variables';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const expenseTypeId = match.params.id && getInt(match.params.id);
  const { t } = useTranslation();
  const expenseName = useReactiveVar(expenseNameVar);

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/leasingExpenseTypes/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
          {`${t('LeasingExpenseType.Title')}:${expenseName ? ` ${expenseName}` : ' - / -'}`}
        </Typography>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <IconButton tooltip={t('BackToList')} color='transparent' onClick={() => historyContext.push(`/leasingExpenseTypes`)}>
          <ArrowBack />
        </IconButton>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_LEASING_EXPENSE_TYPES_READ}>
        <LeasingExpenseTypeContainer expenseTypeId={expenseTypeId} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
